import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { Encoder, EncoderType } from 'src/app/core/models/encoder.model';
import { CardReaderTechType } from './http/api-settings.service';
import { CardStatus } from 'src/app/core/models/card/card-status.model';
import { ApiCardReaderService } from 'src/app/core/services/api-card-reader.service';
import { AlertController, ToastController } from '@ionic/angular';
import { CustomTranslatePipe } from 'src/app/shared/pipes/custom-translate.pipe';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root',
})
export class EncoderSelectionService {
  private selectedEncoder$ = new BehaviorSubject<Encoder>(undefined);

  constructor(
    private apiCardReaderService: ApiCardReaderService,
    private alertController: AlertController,
    private translatePipe: CustomTranslatePipe,
    private router: Router,
    private toastController: ToastController
  ) {}

  public getSelectedEncoder(): Observable<Encoder> {
    return this.selectedEncoder$.asObservable();
  }

  public getSelectedEncoderValue(): Encoder {
   return this.selectedEncoder$.getValue()
  }

  selectEncoder(value: Encoder) {
    this.selectedEncoder$.next(value);
    Encoder.setEncoderDataToStorage(value);
  }


   getCard(cardReaderTechType: CardReaderTechType | 0):Observable<CardStatus> {
    const selectedEncoder = this.selectedEncoder$.getValue()
      if (selectedEncoder.type === EncoderType.AE) {
      return this.apiCardReaderService.getCardFromAdriaReader(cardReaderTechType)
    } else if (selectedEncoder.type === EncoderType.VDA) {
      return this.apiCardReaderService.getCardFromVdaReader(cardReaderTechType as CardReaderTechType, selectedEncoder.id)
    } else {
       return throwError(() => new Error(`Unsupported encoder type: ${selectedEncoder.type}`));
    }

  }


  async queryEncoderSelection() {
      const alert = await this.alertController.create({
        header: this.translatePipe.transform('Please select an encoder'),
        message: this.translatePipe.transform('There is no card encoder selected for this workstation. Please select one or you will be unable to read cards'),
        cssClass: 'select-encoder-modal',
        buttons: [
           {
            text: this.translatePipe.transform('Use local encoder'),
            handler: () => {
              this.selectLocalEncoder();
            },
          },
          {
            text: this.translatePipe.transform('Go to selection screen'),
            handler: () => {
              this.router.navigate(['/settings/encoders']);
            },
          },
          {
            text: this.translatePipe.transform('Ignore and do not remind me'),
            handler: () => {
              Encoder.ignoreSelection();
            },
          },
          {
            text: this.translatePipe.transform('Remind me later'),
            handler: () => {},
          }
        ],
      });
      await alert.present();
    }

   async selectLocalEncoder() {
    const localEncoder: Encoder = {
      id: 999999,
      code: '999999',
      ipAddress: 'http://localhost',
      ipPort: 9986,
      requestTimeoutSeconds: 1,
      requestIntervalMiliSeconds: 500,
      readingLoopTimeoutSeconds: 30,
      sleepBetweenCardsMiliSeconds: 500,
      type: EncoderType.AE,
    };
    this.selectEncoder(localEncoder);
    const toast = await this.toastController.create({
      message: this.translatePipe.transform(
        'Encoder selected. Please refresh page for this to take effect'
      ),
      duration: 10000,
    });
    await toast.present();
  }

}
